<template>
  <div class="tool-wrap-item">
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane
        v-for="(item, index) in unitList"
        :key="index"
        :label="item.desc"
        :name="item.name"
      ></el-tab-pane>
    </el-tabs>
    <div class="tool-wrap-item-content second">
      <div class="unit-show-wrap">
        <div class="unit-wrap">
          <span class="unit-value">{{ unitFromValue || 0 }}</span>
          <span class="unit-name">{{ getUnitInfo().unitFrom }}</span>
        </div>
        <span class="symbol">=</span>
        <div class="unit-wrap">
          <span class="unit-value">{{ unitToValue || 0 }}</span>
          <span class="unit-name">{{ getUnitInfo().unitTo }}</span>
        </div>
      </div>

      <div class="unit-input-wrap">
        <div class="unit-input-content">
          <el-input-number
            v-model="unitFromValue"
            placeholder="请输入数值"
            :precision="5"
            :min="0"
            class="custom-input-number"
            @blur="fromChange"
          ></el-input-number>
          <el-select
            v-model="unitFrom"
            popper-class="supportTool-select-popper"
            placeholder="请选择"
            @change="fromChange"
          >
            <el-option-group
              v-for="group in unitOptionGroup"
              :key="group.label"
              :label="group.label"
            >
              <el-option
                v-for="item in group.options"
                :key="item.symbol"
                :label="`${item.zhName}${
                  item.unit ? '(' + item.unit + ')' : ''
                }`"
                :value="item.symbol"
              >
              </el-option>
            </el-option-group>
          </el-select>
        </div>
        <div class="unit-convert-img">
          <img
            @click="reverseUnit"
            src="@/assets/img/meterSelection/convert.png"
          />
        </div>
        <div class="unit-input-content">
          <el-input-number
            v-model="unitToValue"
            placeholder="请输入数值"
            :precision="5"
            :min="0"
            class="custom-input-number"
            @blur="toChange"
          ></el-input-number>
          <el-select
            v-model="unitTo"
            popper-class="supportTool-select-popper"
            placeholder="请选择"
            @change="toChange"
          >
            <el-option-group
              v-for="group in unitOptionGroup"
              :key="group.label"
              :label="group.label"
            >
              <el-option
                v-for="item in group.options"
                :key="item.symbol"
                :label="`${item.zhName}${
                  item.unit ? '(' + item.unit + ')' : ''
                }`"
                :value="item.symbol"
              >
              </el-option>
            </el-option-group>
          </el-select>
        </div>
      </div>
    </div>

    <!-- 单位展示 -->
    <div class="tool-wrap-item-content second">
      <div class="unit-convert-wrap">
        <div
          class="unit-convert-item"
          v-for="(item, index) in ['imperial', 'metric', 'traditional']"
          :key="index"
        >
          <div v-if="unitParam[item] && unitParam[item].systemName">
            <div class="title">{{ unitParam[item].systemName.zh }}</div>

            <div class="unit-convert-list">
              <div
                class="unit-convert-list-item"
                v-for="(unit, unitIndex) in unitParam[item].units"
                :key="unitIndex"
              >
                <!-- <span class="unit-value">{{ unit.value || '0' }}</span> -->
                <span class="unit-name">{{ unit.zhName }}</span>
                <span class="unit-unit" v-if="unit.unit"
                  >（{{ unit.unit }}）</span
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      activeName: '',
      unitList: [],
      unitParam: {
        imperial: {
          units: [],
          systemName: {}
        },
        metric: {
          units: [],
          systemName: {}
        },
        traditional: {
          units: [],
          systemName: {}
        }
      },
      unitFrom: '',
      unitTo: '',
      unitFromValue: undefined,
      unitToValue: undefined
    }
  },
  computed: {
    // 所有的单位数组集合
    unitOptions () {
      let keys = ['imperial', 'metric', 'traditional'].filter((item) => {
        return this.unitParam[item]
      })
      const units = []
      keys.forEach((key) => {
        units.push(
          ...((this.unitParam[key] && this.unitParam[key].units) || [])
        )
      })
      return units
    },
    // 按照公制英制或市制分组
    unitOptionGroup () {
      let keys = ['imperial', 'metric', 'traditional'].filter((item) => {
        return this.unitParam[item]
      })
      // 可以分组
      return keys.map((key) => {
        return {
          label: this.unitParam[key] && this.unitParam[key].systemName.zh,
          options: [
            ...((this.unitParam[key] && this.unitParam[key].units) || [])
          ]
        }
      })
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {
      this.$http.get('/help/ai/tool/unit/systems').then(({ data: res }) => {
        if (res.code === 0 && res.data.length) {
          this.unitList = res.data || []

          this.activeName = res.data[0].name
          this.handleClick()
        }
      })
    },
    reverseUnit () {
      [this.unitFrom, this.unitTo] = [this.unitTo, this.unitFrom]
      this.fromChange()
    },
    getUnitInfo () {
      if (this.unitFrom && this.unitTo) {
        const fromRes = this.unitOptions.find((item) => {
          return item.symbol === this.unitFrom
        })
        const toRes = this.unitOptions.find((item) => {
          return item.symbol === this.unitTo
        })

        return {
          unitFrom: (fromRes && fromRes.zhName) || '',
          unitTo: (toRes && toRes.zhName) || ''
        }
      } else {
        return {
          unitFrom: '',
          unitTo: ''
        }
      }
    },
    // 单位过滤相同symbol的
    filterUnit (unit) {
      for (let key in unit) {
        if (!unit[key]) return
        let arr = []
        let arrKey = {}
        if (unit[key].units) {
          unit[key].units.forEach((item) => {
            if (!arrKey[item.symbol]) {
              arr.push(item)
              arrKey[item.symbol] = item.zhName
            }
          })
          unit[key].units = arr
        } else {
          this.$set(unit[key], 'units', [])
        }
      }
    },
    fromChange () {
      if (this.unitFrom && this.unitTo) {
        if (this.unitFromValue || this.unitFromValue === 0) {
          this.$http
            .post('/help/ai/tool/unit/convert', {
              fromUnitSymbol: this.unitFrom,
              toUnitSymbol: this.unitTo,
              value: this.unitFromValue
            })
            .then(({ data: res }) => {
              if (res.code === 0) {
                this.unitToValue = res.data.result
              }
            })
        } else if (this.unitToValue || this.unitToValue === 0) {
          this.$http
            .post('/help/ai/tool/unit/convert', {
              fromUnitSymbol: this.unitTo,
              toUnitSymbol: this.unitFrom,
              value: this.unitToValue
            })
            .then(({ data: res }) => {
              if (res.code === 0) {
                this.unitFromValue = res.data.result
              }
            })
        }
      }
    },
    toChange () {
      if (this.unitFrom && this.unitTo) {
        if (this.unitToValue || this.unitToValue === 0) {
          this.$http
            .post('/help/ai/tool/unit/convert', {
              fromUnitSymbol: this.unitTo,
              toUnitSymbol: this.unitFrom,
              value: this.unitToValue
            })
            .then(({ data: res }) => {
              if (res.code === 0) {
                this.unitFromValue = res.data.result
              }
            })
        } else if (this.unitFromValue || this.unitFromValue === 0) {
          this.$http
            .post('/help/ai/tool/unit/convert', {
              fromUnitSymbol: this.unitFrom,
              toUnitSymbol: this.unitTo,
              value: this.unitFromValue
            })
            .then(({ data: res }) => {
              if (res.code === 0) {
                this.unitToValue = res.data.result
              }
            })
        }
      }
    },
    // 单位切换
    handleClick () {
      this.unitFromValue = undefined
      this.unitToValue = undefined
      this.unitFrom = ''
      this.unitTo = ''

      this.$http
        .get('/help/ai/tool/unit/units?name=' + this.activeName)
        .then(({ data: res }) => {
          this.unitParam = res.data || {
            imperial: {
              units: [],
              systemName: {}
            },
            metric: {
              units: [],
              systemName: {}
            },
            traditional: {
              units: [],
              systemName: {}
            }
          }
          this.filterUnit(this.unitParam)
        })
    }
  }
}
</script>
<style lang="scss" scoped>
/deep/ .el-tabs {
  background: #fff;
  margin: -19px -11px 19px -19px;
  padding: 0;

  .el-tabs__header {
    margin-bottom: 0;
  }

  .el-tabs__nav-wrap {
    &::after {
      height: 1px;
    }

    .el-tabs__nav-next,
    .el-tabs__nav-prev {
      line-height: 50px;
      font-size: 16px;
    }
  }

  .el-tabs__item {
    font-size: 14px;
    height: 50px;
    line-height: 50px;
    color: #666666;

    &:nth-child(2),
    &:last-child {
      padding: 0 20px !important;
    }

    &.is-active {
      color: #2a54d1;
      font-weight: bold;
      position: relative;

      &:after {
        content: "";
        height: 2px;
        width: 100%;
        background-color: #2a54d1;
        position: absolute;
        bottom: 0;
        left: 0;
      }
    }
  }

  .el-tabs__active-bar {
    display: none;
  }
}

.unit-show-wrap {
  display: flex;
  margin-bottom: 18px;

  .unit-wrap {
    .unit-value {
      font-size: 22px;
      line-height: 22px;
      font-weight: bold;
      color: #3d3d3d;
      margin-right: 6px;
    }

    .unit-name {
      font-size: 12px;
      line-height: 16px;
      color: rgba(61, 61, 61, 0.5);
    }

    .unit-unit {
      font-size: 12px;
      line-height: 16px;
      color: rgba(61, 61, 61, 0.5);
    }
  }

  .symbol {
    margin: 0 24px;
  }
}

.unit-input-wrap {
  .unit-input-content {
    display: flex;

    .custom-input-number {
      margin-right: 16px;

      /deep/ input {
        background: #f6f5fa;
        border: 1px solid #f6f5fa;

        &:focus {
          border: 1px solid #2a54d1;
        }
      }
    }
  }

  .unit-convert-img {
    width: 43px;
    height: 43px;
    margin: 11px auto;
    cursor: pointer;

    img {
      width: 100%;
    }
  }
}

.unit-convert-wrap {
  padding: 0 12px;

  .unit-convert-item {
    text-align: center;

    .title {
      font-size: 16px;
      font-weight: 500;
      line-height: 22px;
      color: rgba(0, 0, 0, 0.9);
      position: relative;
      margin-bottom: 22px;
    }

    .unit-convert-list {
      display: flex;
      flex-wrap: wrap;
      text-align: left;
      margin-bottom: 12px;

      .unit-convert-list-item {
        width: 33.33%;
        width: calc(100% / 3);
        padding: 10px 4px;
        border-bottom: 1px solid rgba(221, 221, 221, 0.2);

        &:nth-child(3n-1) {
          padding-left: 20px;
        }
        &:nth-child(3n) {
          padding-left: 20px;
        }

        .unit-value {
          font-size: 22px;
          line-height: 22px;
          font-weight: bold;
          color: #3d3d3d;
          margin-right: 6px;
        }

        .unit-name {
          font-size: 12px;
          line-height: 16px;
          color: rgba(61, 61, 61, 0.5);
        }

        .unit-unit {
          font-size: 12px;
          line-height: 16px;
          color: rgba(61, 61, 61, 0.5);
        }
      }
    }
  }
}
</style>
